import React, { createContext, useContext, useEffect, useState } from "react";

import { AlephiumWalletProvider } from '@alephium/web3-react'
import { NetworkId, web3 } from "@alephium/web3";
import PendingTX from "src/components/pendingTX/PendingTX";

interface AppContextType {
   showPendingTX: (txID: string) => void,
   closePendingTX: () => void,
}

export const ApadContext = createContext<AppContextType>({
   showPendingTX: () => { },
   closePendingTX: () => { },
});

export const useAppContext = () => useContext(ApadContext);

const AppProvider = ({ children }) => {
   const [alphPrice, setAlphPrice] = useState<number>(0);
   const [isPendingTXOpen, setIsPendingTXOpen] = useState(false);
   const [pendingTXId, setPendingTXId] = useState<string>("");


   const showPendingTX = (txID: string) => {
      setPendingTXId(txID);
      setIsPendingTXOpen(true);
   }
   const closePendingTX = () => {
      setPendingTXId("");
      setIsPendingTXOpen(false);
   }

   return (
      <AlephiumWalletProvider
         network={process.env.REACT_APP_NETWORK as NetworkId}
         addressGroup={parseInt(process.env.REACT_APP_ACCOUNT_GROUP ?? "0")}
         theme="simple-dark"
      >

         <ApadContext.Provider value={{ showPendingTX, closePendingTX }}>
            {children}
            <PendingTX isOpen={isPendingTXOpen} onClose={closePendingTX} txID={pendingTXId}></PendingTX>
         </ApadContext.Provider>
      </AlephiumWalletProvider>
   );
};

export default AppProvider;